import { MENU_CODE } from '~/constants/menu'

export const useProductSection = () => {
  const eventName: string = 'click_product_home'
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const { getPath } = useNavigationMenu()

  const eventHomeProduct = (product: string) => {
    analyticEvent({
        ga4ActionName: 'click_product_home',
        ga4Label: product,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Product / Service - Home',
      fbValue: { label: product },
    })
  }

  return {
    MENU_CODE,
    eventName,
    eventHomeProduct,
    getPath,
  }
}
